var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgramHubSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8125 19.6562H26.0312V17C26.0312 16.7067 25.7938 16.4688 25.5 16.4688H17.5312V14.3438H22.3125C22.6063 14.3438 22.8438 14.1058 22.8438 13.8125V5.3125C22.8438 5.01925 22.6063 4.78125 22.3125 4.78125H11.6875C11.3942 4.78125 11.1562 5.01925 11.1562 5.3125V13.8125C11.1562 14.1058 11.3942 14.3438 11.6875 14.3438H16.4688V16.4688H8.5C8.20675 16.4688 7.96875 16.7067 7.96875 17V19.6562H3.1875C2.89425 19.6562 2.65625 19.8937 2.65625 20.1875V28.6875C2.65625 28.9813 2.89425 29.2188 3.1875 29.2188H13.8125C14.1058 29.2188 14.3438 28.9813 14.3438 28.6875V20.1875C14.3438 19.8937 14.1058 19.6562 13.8125 19.6562H9.03125V17.5312H24.9688V19.6562H20.1875C19.8937 19.6562 19.6562 19.8937 19.6562 20.1875V28.6875C19.6562 28.9813 19.8937 29.2188 20.1875 29.2188H30.8125C31.1063 29.2188 31.3438 28.9813 31.3438 28.6875V20.1875C31.3438 19.8937 31.1063 19.6562 30.8125 19.6562Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramHubSelected);
export default __webpack_public_path__ + "static/media/programHubSelected.419bbac0bb83c4d15a1fff56221b860b.svg";
export { ForwardRef as ReactComponent };